import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer id="footer">
      <div className="container">

        {/* ── Top: 4 columns ── */}
        <div className="footer-top row">

          {/* Brand */}
          <div className="col-lg-4 col-md-6 footer-col footer-brand">
            <Link to="/" className="footer-logo">
              <img src="/assets/imgs/theme/logonew.jpeg" alt="A and U Wholeseller"
                onError={e => { e.target.style.display = 'none'; }} />
            </Link>
            <p>
              A &amp; U Wholeseller is an e-commerce &amp; wholesale supply brand offering
              competitive pricing for retailers, resellers, and online sellers. From home
              essentials to pet accessories, we deliver quality products at wholesale prices.
            </p>
          </div>

          {/* Information */}
          <div className="col-lg-2 col-md-6 footer-col">
            <h5 className="footer-col-title">Information</h5>
            <ul className="footer-links">
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
              <li><Link to="/purchase-guide">How To Order</Link></li>
              <li><Link to="/terms">Returns &amp; Exchange</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/blog-category-grid">Blog</Link></li>
            </ul>
          </div>

          {/* Customer Services */}
          <div className="col-lg-3 col-md-6 footer-col">
            <h5 className="footer-col-title">Customer Services</h5>
            <ul className="footer-links">
              <li><Link to="/shop">Shop</Link></li>
              <li><Link to="/shop-cart">View Cart</Link></li>
              <li><Link to="/shop-wishlist">Wishlist</Link></li>
              <li><Link to="/shop-checkout">Checkout</Link></li>
              <li><Link to="/shop-compare">Compare</Link></li>
              <li><Link to="/account?tab=orders">Track Order</Link></li>
            </ul>
          </div>

          {/* Store Information */}
          <div className="col-lg-3 col-md-6 footer-col">
            <h5 className="footer-col-title">Store Information</h5>
            <ul className="footer-store list-unstyled">
              <li>
                <i className="icon icon-map-pin"></i>
                <span>5900 Balcones Drive 28919,<br />Austin TX, USA 78731</span>
              </li>
              <li>
                <i className="icon icon-phone"></i>
                <span>+1 (512) 355-5036</span>
              </li>
              <li>
                <i className="icon icon-mail"></i>
                <a href="mailto:aanduwholesellersllc@gmail.com">aanduwholesellersllc@gmail.com</a>
              </li>
              <li>
                <i className="icon icon-help_outline"></i>
                <span>Mon&ndash;Sat: 10:00 AM to 06:00 PM</span>
              </li>
            </ul>
          </div>
        </div>

        {/* ── Centered social icons ── */}
        <div className="footer-social-row">
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><i className="icon icon-facebook"></i></a>
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><i className="icon icon-instagram"></i></a>
          <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter"><i className="icon icon-twitter"></i></a>
          <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" aria-label="YouTube"><i className="icon icon-youtube-play"></i></a>
        </div>

        {/* ── Bottom bar ── */}
        <div className="footer-bottom-bar">
          <p className="copyright">
            &copy; {year} <strong>A &amp; U Wholeseller</strong>. All Rights Reserved. &nbsp;|&nbsp; <Link to="/privacy-policy">Privacy Policy</Link>
          </p>
          <div className="footer-pay">
            <span>100% Safe Checkout</span>
            <span className="pay-cards">
              <img src="/ultras/images/visa-icon.jpg" alt="Visa" />
              <img src="/ultras/images/mastercard.png" alt="Mastercard" />
              <img src="/ultras/images/american-express.jpg" alt="American Express" />
            </span>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
